import { render, staticRenderFns } from "./InventoryItem.vue?vue&type=template&id=ea8db970&scoped=true&"
import script from "./InventoryItem.vue?vue&type=script&lang=js&"
export * from "./InventoryItem.vue?vue&type=script&lang=js&"
import style0 from "./InventoryItem.vue?vue&type=style&index=0&id=ea8db970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8db970",
  null
  
)

export default component.exports